export default "__VITE_ASSET__8UIazvxz__"